module.exports = __webpack_public_path__ + "img/ei-envelope.bdaa8574.svg";